export enum ISO6391 {
    Abkhazian = 'ab',
    Afar = 'aa',
    Afrikaans = 'af',
    Akan = 'ak',
    Albanian = 'sq',
    Amharic = 'am',
    Arabic = 'ar',
    Aragonese = 'an',
    Armenian = 'hy',
    Assamese = 'as',
    Avaric = 'av',
    Avestan = 'ae',
    Aymara = 'ay',
    Azerbaijani = 'az',
    Bambara = 'bm',
    Bashkir = 'ba',
    Basque = 'eu',
    Belarusian = 'be',
    Bengali = 'bn',
    Bihari = 'bh',
    Bislama = 'bi',
    Bosnian = 'bs',
    Breton = 'br',
    Bulgarian = 'bg',
    Burmese = 'my',
    Catalan = 'ca',
    Khmer = 'km',
    Chamorro = 'ch',
    Chechen = 'ce',
    Nyanja = 'ny',
    Chinese = 'zh',
    ChurchSlavonic = 'cu',
    Chuvash = 'cv',
    Cornish = 'kw',
    Corsican = 'co',
    Cree = 'cr',
    Croatian = 'hr',
    Czech = 'cs',
    Danish = 'da',
    Dhivehi = 'dv',
    Dutch = 'nl',
    Dzongkha = 'dz',
    English = 'en',
    Esperanto = 'eo',
    Estonian = 'et',
    Ewe = 'ee',
    Faroese = 'fo',
    Fijian = 'fj',
    Finnish = 'fi',
    French = 'fr',
    Fulah = 'ff',
    Gaelic = 'gd',
    Galician = 'gl',
    Ganda = 'lg',
    Georgian = 'ka',
    German = 'de',
    Kikuyu = 'ki',
    Greek = 'el',
    Kalaallisut = 'kl',
    Guarani = 'gn',
    Gujarati = 'gu',
    Haitian = 'ht',
    Hausa = 'ha',
    Hebrew = 'he',
    Herero = 'hz',
    Hindi = 'hi',
    HiriMotu = 'ho',
    Hungarian = 'hu',
    Icelandic = 'is',
    Ido = 'io',
    Igbo = 'ig',
    Indonesian = 'id',
    Interlingua = 'ia',
    Interlingue = 'ie',
    Inuktitut = 'iu',
    Inupiaq = 'ik',
    Irish = 'ga',
    Italian = 'it',
    Japanese = 'ja',
    Javanese = 'jv',
    Kannada = 'kn',
    Kanuri = 'kr',
    Kashmiri = 'ks',
    Kazakh = 'kk',
    Kinyarwanda = 'rw',
    Komi = 'kv',
    Kongo = 'kg',
    Korean = 'ko',
    Kwanyama = 'kj',
    Kurdish = 'ku',
    Kyrgyz = 'ky',
    Lao = 'lo',
    Latin = 'la',
    Latvian = 'lv',
    Luxembourgish = 'lb',
    Limburgish = 'li',
    Lingala = 'ln',
    Lithuanian = 'lt',
    LubaKatanga = 'lu',
    Macedonian = 'mk',
    Malagasy = 'mg',
    Malay = 'ms',
    Malayalam = 'ml',
    Maltese = 'mt',
    Manx = 'gv',
    Maori = 'mi',
    Marathi = 'mr',
    Marshallese = 'mh',
    Romanian = 'ro',
    Mongolian = 'mn',
    Nauru = 'na',
    Navajo = 'nv',
    NorthernNdebele = 'nd',
    Ndonga = 'ng',
    Nepali = 'ne',
    NorthernSami = 'se',
    Norwegian = 'no',
    NorwegianBokmål = 'nb',
    NorwegianNynorsk = 'nn',
    SichuanYi = 'ii',
    Occitan = 'oc',
    Ojibwa = 'oj',
    Oriya = 'or',
    Oromo = 'om',
    Ossetian = 'os',
    Pali = 'pi',
    Punjabi = 'pa',
    Pashto = 'ps',
    Persian = 'fa',
    Polish = 'pl',
    Portuguese = 'pt',
    Quechua = 'qu',
    Romansh = 'rm',
    Rundi = 'rn',
    Russian = 'ru',
    Samoan = 'sm',
    Sango = 'sg',
    Sanskrit = 'sa',
    Sardinian = 'sc',
    Serbian = 'sr',
    Shona = 'sn',
    Sindhi = 'sd',
    Sinhalese = 'si',
    Slovak = 'sk',
    Slovenian = 'sl',
    Somali = 'so',
    Sotho = 'st',
    SouthNdebele = 'nr',
    Spanish = 'es',
    Sundanese = 'su',
    Swahili = 'sw',
    Swati = 'ss',
    Swedish = 'sv',
    Tagalog = 'tl',
    Tahitian = 'ty',
    Tajik = 'tg',
    Tamil = 'ta',
    Tatar = 'tt',
    Telugu = 'te',
    Thai = 'th',
    Tibetan = 'bo',
    Tigrinya = 'ti',
    Tonga = 'to',
    Tsonga = 'ts',
    Tswana = 'tn',
    Turkish = 'tr',
    Turkmen = 'tk',
    Twi = 'tw',
    Uighur = 'ug',
    Ukrainian = 'uk',
    Urdu = 'ur',
    Uzbek = 'uz',
    Venda = 've',
    Vietnamese = 'vi',
    Volapiük = 'vo',
    Walloon = 'wa',
    Welsh = 'cy',
    WesternFrisian = 'fy',
    Wolof = 'wo',
    Xhosa = 'xh',
    Yiddish = 'yi',
    Yoruba = 'yo',
    Zhuang = 'za',
    Zulu = 'zu',
}
